// @flow

import { useContext } from 'react';

import { type PaymentSpec } from './types';
import { PaymentSpecContext  } from './context';

export function usePaymentSpec(): PaymentSpec {
  const context = useContext(PaymentSpecContext);
  if (!context) {
    throw new Error('PaymentSpecContext was not provided');
  }
  return context;
}
